import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { TableLayout } from '../../Menu/Stock/containers/Layout';
import { isEmpty } from "lodash"
import CommercialPopUp from './CommercialPopUp';
import { TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';

class AgentStats extends Component {
    state = {  
        commercial: {},
        openPopUp: false,

    }



    render() {
        const { openPopUp, commercial } = this.state;
        return (
            <div>
                {openPopUp && !isEmpty(commercial) &&
                    <CommercialPopUp
                        closePopUp={() => this.setState({
                            openPopUp: false,
                            commercial: {}
                        })} 
                        commercial={commercial}
                        STOCK_INFO_LIST
                        updateAgent={this.props.updateAgent}
                    />
                }
                <h4>Performance Agents Commerciaux</h4>
                <TableLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell>Nom</TableCell>
                            <TableCell>Nombre de Ventes</TableCell>
                            <TableCell>Nombre de Prospects</TableCell>
                            <TableCell>Commission</TableCell>
                            <TableCell>...</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!isEmpty(this.props.list) && !isEmpty(this.props.AGENTS) && this.props.list.map( agentID => (
                            <TableRow key={agentID} onClick={ () => this.setState({
                                commercial: this.props.AGENTS[agentID],
                                openPopUp: true,
                            })}>
                                <TableCell>{this.props.AGENTS[agentID].name}</TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        )

                        )}
                    </TableBody>
                </TableLayout>
            </div>
        );
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        
        CLIENTS: state.clients
    }
}

// function mapDispatchToProps(dispatch){
//     return bindActionCreators({
//         fetchAgents,
//         updateAgent,
//     }, dispatch)
// }
export default connect( mapStateToProps )(AgentStats);